const schema = [
        ['name'],
        ['timeZone'],
];

export default schema;
